import { render } from "./JemaatTable.vue?vue&type=template&id=d01954c6"
import script from "./JemaatTable.vue?vue&type=script&lang=js"
export * from "./JemaatTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__